import CannotPreviewInBrowser from './CannotPreviewInBrowser.component';

export default CannotPreviewInBrowser;
